import React from 'react';

function isMobile() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

function ResponsiveLayout({ children }) {
  const [isPortrait, setIsPortrait] = React.useState(window.innerHeight > window.innerWidth);
  const [mobile, setMobile] = React.useState(isMobile());

  React.useEffect(() => {
    const handleResize = () => {
      setIsPortrait(window.innerHeight > window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (mobile && isPortrait) {
    return (
      <div
        className="has-background-dark has-text-white is-flex is-flex-direction-column is-align-items-center is-justify-content-center"
        style={{ minHeight: '100vh', padding: '2rem', textAlign: 'center' }}
      >
        <img
          src="https://kukenfi.kukenandev.es/logo/logo_oscuro.svg"
          alt="Kukenfi Logo"
          style={{ width: '120px', marginBottom: '1.5rem' }}
        />
        <h1 className="title is-4">Por favor, gira tu dispositivo</h1>
        <p className="mb-4">Para una mejor experiencia, recomendamos usar modo horizontal o un ordenador.</p>
        <div className="icon is-large">📱🔄</div>
      </div>
    );
  }

  return <>{children}</>;
}

export default ResponsiveLayout;
